import WebApp from '@twa-dev/sdk'
import React from 'react'

const TelegramContext = React.createContext({
  WebApp,
  ready: () => {},
})
const useTelegramContext = () => React.useContext(TelegramContext)

type TelegramProviderProps = {
  children: React.ReactNode
}
const TelegramProvider = ({ children }: TelegramProviderProps) => {
  const [isReady, setReady] = React.useState(false)
  const ready = React.useCallback(() => {
    if (isReady) return
    setReady(true)
    WebApp.ready()
  }, [isReady, setReady, WebApp])

  const value = React.useMemo(() => ({ WebApp, ready }), [WebApp, ready])

  return <TelegramContext.Provider children={children} value={value} />
}

export { TelegramProvider, useTelegramContext }
